(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-related-products"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.section-related-products-inner[data-url]');
  if (!productRecommendationsSection) return;

  const currentHandle = productRecommendationsSection.getAttribute('data-current-handle');
  const lastSeenKey = 'bonnieclyde_last_seen_products';

  // Function to format money using Shopify's format
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents.replace('.', ''), 10);
    }
    const amount = (cents / 100).toFixed(2);
    const formatted = amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return '$' + formatted;
  }

  // Function to create product card HTML from JSON data
  function createProductCard(productData, storedColor = null) {
    const variant = productData.variants && productData.variants.length > 0 ? productData.variants[0] : null;
    if (!variant) return '';

    // Shopify JSON API returns featured_image as string URL and images as array of objects with src property
    const mainImage =
      productData.featured_image ||
      (productData.images && productData.images.length > 0 ? productData.images[0].src || productData.images[0] : null);
    const secondaryImage =
      productData.images && productData.images.length > 1 ? productData.images[1].src || productData.images[1] : null;

    // Get image URLs - Shopify JSON API returns full URLs, we need to extract and resize
    const getImageUrl = (url, width) => {
      if (!url) return '';
      const imageUrl = typeof url === 'string' ? url : url.src || url;
      // Shopify CDN URLs can be resized by replacing the size parameter or appending it
      // Format: https://cdn.shopify.com/.../image_600x600.jpg
      if (imageUrl.includes('_')) {
        return imageUrl.replace(/_\d+x\d+/, `_${width}x${width}`);
      }
      // If no size parameter, try to insert it before the file extension
      return imageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, `_${width}x${width}.$1`);
    };

    let cardHTML = '<div class="product-card">';
    cardHTML += `<a href="${productData.url}" class="product-card-link">`;
    cardHTML += '<div class="product-card-image-wrapper">';

    if (mainImage) {
      const mainImage600 = getImageUrl(mainImage, 600);
      const mainImage300 = getImageUrl(mainImage, 300);
      cardHTML += `<img
        src="${mainImage600}"
        srcset="${mainImage300} 1x, ${mainImage600} 2x"
        alt="${(productData.title || '').replace(/"/g, '&quot;')}"
        class="product-card-image product-card-image-main"
        loading="lazy"
      >`;
    }

    if (secondaryImage) {
      const secondaryImage600 = getImageUrl(secondaryImage, 600);
      const secondaryImage300 = getImageUrl(secondaryImage, 300);
      cardHTML += `<img
        src="${secondaryImage600}"
        srcset="${secondaryImage300} 1x, ${secondaryImage600} 2x"
        alt="${(productData.title || '').replace(/"/g, '&quot;')}"
        class="product-card-image product-card-image-secondary"
        loading="lazy"
      >`;
    }

    cardHTML += '</div>';
    cardHTML += '<div class="product-card-info">';

    // Title - capitalize first letter of each word
    const title = productData.title || '';
    const capitalizedTitle = title
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    cardHTML += `<div class="product-card-name">${capitalizedTitle}</div>`;

    // Add color if available (from stored data)
    if (storedColor) {
      cardHTML += '<div class="product-card-color-wrapper">';
      cardHTML += `<div class="product-card-color">${storedColor}</div>`;
      cardHTML += '</div>';
    }

    cardHTML += '<div class="product-card-price">';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      cardHTML += `<span class="product-card-price-compare">${formatMoney(variant.compare_at_price)}</span>`;
    }
    cardHTML += `<span class="product-card-price-current">${formatMoney(variant.price)}</span>`;
    cardHTML += '</div>';
    cardHTML += '</div>';
    cardHTML += '</a>';
    cardHTML += '</div>';

    return cardHTML;
  }

  // Make loadLastSeenProducts globally accessible for Alpine component
  window.loadLastSeenProducts = async function loadLastSeenProducts(grid, currentHandle, lastSeenKey) {
    if (typeof Storage === 'undefined') {
      grid.innerHTML = '<p>Local storage is not available.</p>';
      return;
    }

    const lastSeen = JSON.parse(localStorage.getItem(lastSeenKey) || '[]');

    // Handle both old format (array of strings) and new format (array of objects)
    const filteredLastSeen = lastSeen
      .filter((item) => {
        const handle = typeof item === 'string' ? item : item.handle;
        return handle !== currentHandle;
      })
      .slice(0, 4);

    if (filteredLastSeen.length === 0) {
      grid.innerHTML = '<p>No recently viewed products.</p>';
      return;
    }

    try {
      // Extract handles and colors
      const handles = filteredLastSeen.map((item) => (typeof item === 'string' ? item : item.handle));
      const colorMap = {};
      filteredLastSeen.forEach((item) => {
        if (typeof item === 'object' && item.handle && item.color) {
          colorMap[item.handle] = item.color;
        }
      });

      // Fetch all products in parallel
      const productPromises = handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP ${res.status}`);
            }
            return res.json();
          })
          .then((product) => ({ product, handle }))
          .catch((err) => {
            console.error(`Error fetching product ${handle}:`, err);
            return null;
          })
      );

      const results = await Promise.all(productPromises);
      const validProducts = results.filter((r) => r !== null);

      if (validProducts.length === 0) {
        grid.innerHTML = '<p>No recently viewed products available.</p>';
        return;
      }

      // Filter out rx-only products
      const filteredProducts = validProducts.filter(({ product }) => {
        if (product.tags && product.tags.includes('rx-only')) {
          return false;
        }
        return true;
      });

      if (filteredProducts.length === 0) {
        grid.innerHTML = '<p>No recently viewed products available.</p>';
        return;
      }

      // Render products with stored color data
      grid.innerHTML = '';
      filteredProducts.slice(0, 4).forEach(({ product, handle }) => {
        const storedColor = colorMap[handle] || null;
        const cardHTML = createProductCard(product, storedColor);
        if (cardHTML) {
          grid.insertAdjacentHTML('beforeend', cardHTML);
        }
      });
    } catch (error) {
      console.error('Error loading last seen products:', error);
      grid.innerHTML = '<p>Error loading recently viewed products.</p>';
    }
  };

  // Function to load recommendations
  function loadRecommendations(target, unobserve = false) {
    const url = target.getAttribute('data-url');
    if (!url) {
      console.error('No data-url found on element:', target);
      return;
    }

    const similarView = target.querySelector('.section-related-products-content[data-view="similar"]');
    const existingProducts = similarView ? similarView.querySelectorAll('.product-card').length : 0;

    // Only fetch if we don't have products yet
    // (recommendations might not be performed on initial page load)
    if (existingProducts > 0) {
      return;
    }

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.section-related-products-inner');

        if (!recommendations) {
          console.warn('Recommendations section not found in response');
          return;
        }

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Try to find content - it might not have data-view attribute in the response
          let content = recommendations.querySelector('.section-related-products-content[data-view="similar"]');
          if (!content) {
            // Fallback: get first content element
            content = recommendations.querySelector('.section-related-products-content');
          }

          if (content) {
            if (similarView) {
              const grid = similarView.querySelector('.section-related-products-grid');
              if (grid) {
                const fetchedGrid = content.querySelector('.section-related-products-grid');
                if (fetchedGrid && fetchedGrid.innerHTML.trim()) {
                  grid.innerHTML = fetchedGrid.innerHTML;
                } else {
                  // Try to find product cards directly in content
                  const productCards = content.querySelectorAll('.product-card');
                  if (productCards.length > 0) {
                    grid.innerHTML = '';
                    productCards.forEach((card) => {
                      grid.appendChild(card.cloneNode(true));
                    });
                  } else {
                    // Fallback: use the entire content
                    grid.innerHTML = content.innerHTML;
                  }
                }
              } else {
                // Fallback: replace entire similarView content
                similarView.innerHTML = content.innerHTML;
              }

              // Check if we have at least 4 products
              const productCards = similarView.querySelectorAll('.product-card');

              // Limit to 4 products if we have more
              if (productCards.length > 4) {
                const grid = similarView.querySelector('.section-related-products-grid');
                Array.from(productCards).forEach((card, index) => {
                  if (index >= 4) {
                    card.remove();
                  }
                });
              }

              // If we have fewer than 4, fetch complementary products
              const finalCards = similarView.querySelectorAll('.product-card');
              if (finalCards.length < 4) {
                // Extract product_id from the original URL
                const urlParams = new URLSearchParams(url.split('?')[1]);
                const productId = urlParams.get('product_id');
                const sectionId = urlParams.get('section_id');

                if (productId) {
                  // Fetch complementary products to fill the gap
                  const needed = 4 - finalCards.length;
                  const complementaryUrl = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${
                    needed + 2
                  }&intent=complementary`;

                  fetch(complementaryUrl)
                    .then((response) => {
                      if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                      }
                      return response.text();
                    })
                    .then((complementaryText) => {
                      const complementaryHtml = document.createElement('div');
                      complementaryHtml.innerHTML = complementaryText;
                      const complementarySection = complementaryHtml.querySelector('.section-related-products-inner');

                      if (complementarySection) {
                        const complementaryContent = complementarySection.querySelector(
                          '.section-related-products-content'
                        );
                        if (complementaryContent) {
                          const complementaryCards = complementaryContent.querySelectorAll('.product-card');
                          const grid = similarView.querySelector('.section-related-products-grid');

                          // Get existing product IDs to avoid duplicates
                          const existingIds = new Set();
                          finalCards.forEach((card) => {
                            const link = card.querySelector('a[href]');
                            if (link) {
                              const productUrl = new URL(link.href, window.location.origin);
                              const productHandle = productUrl.pathname.split('/products/')[1];
                              if (productHandle) {
                                existingIds.add(productHandle);
                              }
                            }
                          });

                          // Add complementary products that aren't duplicates
                          let added = 0;
                          complementaryCards.forEach((card) => {
                            if (added >= needed) return;

                            const link = card.querySelector('a[href]');
                            if (link) {
                              const productUrl = new URL(link.href, window.location.origin);
                              const productHandle = productUrl.pathname.split('/products/')[1];

                              if (productHandle && !existingIds.has(productHandle)) {
                                grid.appendChild(card.cloneNode(true));
                                existingIds.add(productHandle);
                                added++;
                              }
                            }
                          });
                        }
                      }
                    })
                    .catch((e) => {
                      console.error('Error fetching complementary products:', e);
                    });
                }
              }
            }
          }
        }
      })
      .catch((e) => {
        console.error('Error fetching recommendations:', e);
        console.error('URL attempted:', url);
        // Show error message in the grid if fetch fails
        const similarView = target.querySelector('.section-related-products-content[data-view="similar"]');
        if (similarView) {
          const grid = similarView.querySelector('.section-related-products-grid');
          if (grid && grid.children.length === 0) {
            grid.innerHTML = '<p style="padding: 2rem; text-align: center;">Unable to load recommendations.</p>';
          }
        }
      });
  }

  // Load recommendations immediately on page load
  // Load recommendations immediately on page load
  const similarViewCheck = productRecommendationsSection.querySelector(
    '.section-related-products-content[data-view="similar"]'
  );
  const existingProductsCheck = similarViewCheck ? similarViewCheck.querySelectorAll('.product-card').length : 0;

  // Load immediately if no products exist (don't wait for intersection)
  if (existingProductsCheck === 0) {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      loadRecommendations(productRecommendationsSection);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
